/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Verification status of a stored document.
 * - NotApplicable: the document type is not subject to automatic verification (default).
 * - Pending: document is uploaded, OCR verification is queued or was not run yet.
 * - Verified: document passed automatic or manual verification.
 * - Rejected: document failed verification; user must re-upload or correct.
 * 
 * @export
 */
export const DocumentVerificationStatusEnum = {
    NotApplicable: 'NotApplicable',
    Pending: 'Pending',
    Verified: 'Verified',
    Rejected: 'Rejected'
} as const;
export type DocumentVerificationStatusEnum = typeof DocumentVerificationStatusEnum[keyof typeof DocumentVerificationStatusEnum];


export function instanceOfDocumentVerificationStatusEnum(value: any): boolean {
    for (const key in DocumentVerificationStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(DocumentVerificationStatusEnum, key)) {
            if (DocumentVerificationStatusEnum[key as keyof typeof DocumentVerificationStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DocumentVerificationStatusEnumFromJSON(json: any): DocumentVerificationStatusEnum {
    return DocumentVerificationStatusEnumFromJSONTyped(json, false);
}

export function DocumentVerificationStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentVerificationStatusEnum {
    return json as DocumentVerificationStatusEnum;
}

export function DocumentVerificationStatusEnumToJSON(value?: DocumentVerificationStatusEnum | null): any {
    return value as any;
}

export function DocumentVerificationStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DocumentVerificationStatusEnum {
    return value as DocumentVerificationStatusEnum;
}

